import styled from 'styled-components';

export const AuthListContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 8;
  padding: 1rem;
  background: #262f3b;
  width: 100%;
  border-radius: 0.5rem;
`;

export const AuthBoxContainer = styled.div`
  flex: 3;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: #1f242c;
  margin: 0px 1rem;
  height: 65vh;
  border-radius: 0.5rem;
  overflow-y: auto;
  overflow-x: hidden;

  & > div.title {
    background: #2f2b43;
    width: 90%;
    margin-top: 1rem;
    text-align: center;
    padding: 0.5rem;
    border-radius: 1rem;
  }

  & > div.content-box {
    height: 100%;
    width: 90%;
    margin: 1rem 0;

    & > div.content {
      padding: 1rem 0.5rem;
      cursor: pointer;
      white-space: nowrap;
      width: 32rem;
      overflow: hidden;

      &:hover {
        background: #262f3b;
      }
    }

    & > div.on {
      background: #262f3b;
    }
  }
`;

export const InnerFactoryAuthBoxContainer = styled.div`
  & > div.content {
    width: 100%;
    overflow: hidden;
    white-space: pre;
    margin-left: 2rem;
    padding: 0 1rem;
    cursor: pointer;
  }

  & > div.on {
    background: #262f3b;
  }
`;
